import { useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { action_setFireLoad, action_setNotificacionTaskList, action_setNotificacionTaskListFiltred, action_setNotificacionTaskMenuItems } from '../../../reducers/actions/NotificationTasks/actions';
import { getNotificationDetails, getNotificationsListByClass, getNotificationsCounter, getNotificationsList, getTotalNotificationsBySection } from '../../../services/sNotificationAlerts/notificationAlerts.service';
import { action_updateAlertCounter, action_updateAlertList, action_updateFirstLoadCounter, action_updateFirstLoadList } from '../../../reducers/actions/SITE/actions';
import { isNullUndefined, isNullUndefinedOrEmpty } from '../../../common/Helpers';

const useGetNotificationTasks = (entb, notificationTaskList, fireLoad, notificationTaskMenuItems) => {    
    const dispatch = useDispatch();

    useEffect(()=> { 
        const getNotificationsData = async (entb) => {
            try {
                let serviceResponse = await getNotificationsList(entb);
                const response = serviceResponse.data;
                const aux = [];
                
                if (response.succeeded) {
                    response.data.forEach(element => {
                        aux.push({...element, expanded: false, editingPriority: false, editingImportant: false});                        
                    });
                }

                dispatch(action_setNotificacionTaskList([...aux]));   
                dispatch(action_setNotificacionTaskListFiltred([...aux]));
            }
            catch (error) {
                dispatch(action_setNotificacionTaskList([]));                
                dispatch(action_setNotificacionTaskListFiltred([]));                
                console.log(error)
            }
        }

        const getNotificationsDataBySection = async (entb) => {
            try {
                let serviceResponse = await getTotalNotificationsBySection(entb);
                const response = serviceResponse.data;
                
                if (response.succeeded) {
                    dispatch(action_setNotificacionTaskMenuItems(response.data)); 
                }
                else {
                    dispatch(action_setNotificacionTaskMenuItems([]));   
                }
            }
            catch (error) {
                dispatch(action_setNotificacionTaskMenuItems([]));   
                console.log(error)
            }
        }

        const getData = async (entb) => {
            if (notificationTaskList === null || fireLoad === true) {
                dispatch(action_setFireLoad(false));
                await getNotificationsData(entb);
            }
            if (notificationTaskMenuItems === null || fireLoad === true) {
                dispatch(action_setFireLoad(false));
                await getNotificationsDataBySection(entb);
            }
        }
        
        if (!isNullUndefinedOrEmpty(entb) && ((notificationTaskList === null || fireLoad === true) && (notificationTaskMenuItems === null || fireLoad === true))) {
            getData(entb);
        }
    }, [entb, notificationTaskList, fireLoad, notificationTaskMenuItems]);
}

const useGetNotificationCounter = (objNotificationCounter, firstLoad) => {    
    const dispatch = useDispatch();

    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getNotificationsCounter();

                if (serviceResponse.data.succeeded) {
                    const response = serviceResponse.data.data;

                    dispatch(action_updateFirstLoadCounter(true))
                    dispatch(action_updateAlertCounter(response))
                }
                else {
                    dispatch(action_updateFirstLoadCounter(true))
                    dispatch(action_updateAlertCounter(0))
                }
            }
            catch (error) {
                    dispatch(action_updateFirstLoadCounter(true))
                    dispatch(action_updateAlertCounter(0))
            }
        }
        
        if (objNotificationCounter === null && firstLoad === false) {
            getData()
        }
    }, [objNotificationCounter]);
}

const useGetNotificationPanelList = (entb, objNotificationList, firstLoad, isPanelOpen) => {    
    const dispatch = useDispatch();

    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = null;

                serviceResponse = await getNotificationsList(entb);

                if (!isNullUndefined(serviceResponse)) {
                    if (serviceResponse.data.succeeded) {
                        const response = serviceResponse.data.data;

                        dispatch(action_updateFirstLoadList(true))
                        dispatch(action_updateAlertList(response))
                    }
                    else {
                        dispatch(action_updateFirstLoadList(true))
                        dispatch(action_updateAlertList([]))
                    }
                }
                else {
                    dispatch(action_updateFirstLoadList(true))
                    dispatch(action_updateAlertList([]))
                }
            }
            catch (error) {
                dispatch(action_updateFirstLoadList(true))
                dispatch(action_updateAlertList([]))
            }
        }
        
        if (!isNullUndefinedOrEmpty(entb), objNotificationList === null && firstLoad === false && isPanelOpen === true) {
            getData()
        }
    }, [entb, objNotificationList, firstLoad, isPanelOpen]);
}

const useGetNotificationPanelListByClass = (parentId, itemId, entb, objNotificationList, firstLoad, isPanelOpen) => {    
    const dispatch = useDispatch();

    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = null;

                serviceResponse = await getNotificationsListByClass(parentId, itemId, entb);

                if (!isNullUndefined(serviceResponse)) {
                    if (serviceResponse.data.succeeded) {
                        const response = serviceResponse.data.data;

                        dispatch(action_updateFirstLoadList(true))
                        dispatch(action_updateAlertList(response))
                    }
                    else {
                        dispatch(action_updateFirstLoadList(true))
                        dispatch(action_updateAlertList([]))
                    }
                }
                else {
                    dispatch(action_updateFirstLoadList(true))
                    dispatch(action_updateAlertList([]))
                }
            }
            catch (error) {
                dispatch(action_updateFirstLoadList(true))
                dispatch(action_updateAlertList([]))
            }
        }
        
        if (!isNullUndefinedOrEmpty(entb), objNotificationList === null && firstLoad === false && isPanelOpen === true) {
            getData()
        }
    }, [itemId, entb, objNotificationList, firstLoad, isPanelOpen]);
}

const useGetNotificationDetails = (notificationTaskId, objNotificationTask, setObjNotificationTask, setAchievemtComment, setValidationComment) => {    
    const dispatch = useDispatch();

    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getNotificationDetails(notificationTaskId);

                if (serviceResponse.data.succeeded) {
                    const response = serviceResponse.data.data;

                    setObjNotificationTask(response)
                    setAchievemtComment(response.item_cumplimiento.comentario)
                    setValidationComment(response.item_cumplimiento.comentarioValidacion)
                }
                else {
                    setObjNotificationTask(undefined)
                    setAchievemtComment("")
                    setValidationComment("")
                }
            }
            catch (error) {
                setObjNotificationTask(undefined)
                setAchievemtComment("")
                setValidationComment("")
            }
        }
        
        if (objNotificationTask === null && notificationTaskId !== null) {
            getData()
        }
    }, [notificationTaskId, objNotificationTask, setAchievemtComment, setValidationComment]);
}

export {
    useGetNotificationTasks,
    useGetNotificationPanelList,
    useGetNotificationPanelListByClass,
    useGetNotificationCounter,
    useGetNotificationDetails
}